// Central HESHAURA social links config. Edit the `url` values here to go live.
// Leave a `url` empty ("") to keep that icon safely disabled until configured —
// never invent a URL. Icons use Font Awesome brand classes (loaded in index.html).

export const SOCIAL_LINKS = [
  { key: "instagram", label: "Instagram", icon: "fa-brands fa-instagram", url: "https://www.instagram.com/heshaura.in" },
  { key: "facebook", label: "Facebook", icon: "fa-brands fa-facebook-f", url: "https://www.facebook.com/people/Heshaura/61594350759054" },
  { key: "youtube", label: "YouTube", icon: "fa-brands fa-youtube", url: "" },
  { key: "whatsapp", label: "WhatsApp", icon: "fa-brands fa-whatsapp", url: "https://whatsapp.com/channel/0029VbE6c4w6WaKsDBlJeA17" },
  { key: "telegram", label: "Telegram", icon: "fa-brands fa-telegram", url: "https://t.me/Heshaura" },
  { key: "pinterest", label: "Pinterest", icon: "fa-brands fa-pinterest-p", url: "https://pin.it/ZA7K34SgO" },
  { key: "twitter", label: "X (Twitter)", icon: "fa-brands fa-x-twitter", url: "" },
];
